import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Docusignpk = Loadable({
  loader: () => import("./components/docusignpk"),
  loading: Loading,
});
const DocusignInterview = Loadable({
  loader: () => import("./components/docusign_interview"),
  loading: Loading,
});

export const routes = [
  {
    path: "/docusignpk",
    exact: true,
    name: "docusignpk",
    component: Docusignpk,
  },
  {
    path: "/docusign_interview",
    exact: true,
    name: "docusign_interview",
    component: DocusignInterview,
  },
];
